import { useEffect, useState } from "react";
import { Customer } from "../datatype";
import { customer_consent_get_customer_profile } from "../../../API/api";
import customFetch from "../../../API/CustomFetch";
import showToastMessage from "../../../Toastify/Index";
import ErrorFallback from "../../ErrorFallback/ErrorFallback";
import LeadCardSkeleton from "../../../layouts/spinners/LeadCardSkeleton";
import { formatDate, mainCategoryMapping } from "../../../utils/utils";

interface CustomerProfileProps {
  typeMasterId?: string | null;
}

const CustomerProfile: React.FC<CustomerProfileProps> = ({ typeMasterId }) => {
  // console.log(
  //   "typeMasterId in CustomerProfile:",
  //   typeMasterId,
  //   typeof typeMasterId
  // );
  const [customer, setCustomer] = useState<Customer | null>(null);
  const [toastShown, setToastShown] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const vehicleProfileId = urlParams.get("vp");
    const url = `${customer_consent_get_customer_profile}/${vehicleProfileId}`;

    setLoading(true);
    customFetch(url)
      .then((res) => {
        if (res.SUCCESS) {
          setCustomer(res.DATA[0]);
        } else {
          setCustomer(null);
          showToastMessage(false, "Contact Support on this.");
        }
      })
      .catch(() => setCustomer(null))
      .finally(() => setLoading(false));
  }, [toastShown]);

  useEffect(() => {
    if (customer && !toastShown) {
      showToastMessage(true, "Welcome to Green Tiger Family");
      setToastShown(true);
    }
  }, [customer]);

  // Helper to show Yes/No/N/A
  const renderYesNoNA = (value: number | null) => {
    if (value == null) return <span className="text-black">N/A</span>;
    return value === 1 ? (
      <span className="text-black">Yes</span>
    ) : (
      <span className="text-black">No</span>
    );
  };

  return (
    <div>
      {loading ? (
        <LeadCardSkeleton />
      ) : customer ? (
        <div className="border border-gray-300 p-4 mb-8 rounded-lg shadow-sm space-y-6">
          {/* Customer Details */}
          <div>
            <h3 className="text-lg font-semibold mb-2">Customer Details</h3>

            {/* --- Personal Information --- */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
              <div>
                <label className="text-gray-600">Name:</label>
                <div>{customer?.LeadName ?? "N/A"}</div>
              </div>
              <div>
                <label className="text-gray-600">Email:</label>
                <div>{customer?.Email ?? "N/A"}</div>
              </div>
              <div>
                <label className="text-gray-600">Mobile No:</label>
                <div>{customer?.MobileNumber ?? "N/A"}</div>
              </div>
              <div>
                <label className="text-gray-600">Address:</label>
                <div>{customer?.Address ?? "N/A"}</div>
              </div>
              <div>
                <label className="text-gray-600">City:</label>
                <div>{customer?.City_Name ?? "N/A"}</div>
              </div>
              <div>
                <label className="text-gray-600">DOB:</label>
                <div>{formatDate(customer?.AgeGroup)}</div>
              </div>
            </div>

            {/* --- Vehicle Details --- */}
            <h3 className="text-lg font-semibold mb-2">Vehicle Details</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
              <div>
                <label className="text-gray-600">
                  Vehicle Registration No:
                </label>
                <div>{customer?.Registration_No ?? "N/A"}</div>
              </div>
              <div>
                <label className="text-gray-600">Brand:</label>
                <div>{customer?.Brand_Name ?? "N/A"}</div>
              </div>
              <div>
                <label className="text-gray-600">Model:</label>
                <div>{customer?.Model_Name ?? "N/A"}</div>
              </div>
              <div>
                <label className="text-gray-600">Manufacturing Year:</label>
                <div>{customer?.MfgYr ?? "N/A"}</div>
              </div>
              <div>
                <label className="text-gray-600">Conversion Type:</label>
                <div>
                  {customer.conversionTypeId != null
                    ? (mainCategoryMapping[customer.conversionTypeId] ?? "N/A")
                    : "N/A"}
                </div>
              </div>
            </div>
          </div>

          {/* --- Pricing Details --- */}
          <div>
            <h3 className="text-lg font-semibold mb-2">Pricing Details</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
              <div>
                <label className="text-gray-600">Conversion Price:</label>
                <div>₹ {customer?.SellingPrice ?? "N/A"}</div>
              </div>
              <div>
                <label className="text-gray-600">Booked Amount:</label>
                <div>₹ {customer?.BookedAmount ?? "N/A"}</div>
              </div>
            </div>
          </div>

          {typeMasterId !== "54" && (
            <div>
              {/* ---Payment Details - Loan & Insurance --- */}
              <div>
                <h3 className="text-lg font-semibold mb-2">Payment Details</h3>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
                  <div>
                    <label className="text-gray-600">
                      Payment preferred mode:
                    </label>
                    <div>{customer?.preferedPaymentModeText ?? "N/A"}</div>
                  </div>
                  <div>
                    <label className="text-gray-600">Loan Applied:</label>
                    <div>{renderYesNoNA(customer?.loan_applied)}</div>
                  </div>
                  {customer?.loan_applied === 1 && (
                    <div>
                      <label className="text-gray-600">Loan Status:</label>
                      <div>{customer?.loan_status ?? "N/A"}</div>
                    </div>
                  )}

                  <div>
                    <label className="text-gray-600">
                      Insurance Interested:
                    </label>
                    <div>{renderYesNoNA(customer?.InsuranceInterested)}</div>
                  </div>
                  <div>
                    <label className="text-gray-600">RSA Interested:</label>
                    <div>{renderYesNoNA(customer?.RSAIntrested)}</div>
                  </div>
                </div>
              </div>

              {/*Special Request-  Parts To Be Returned */}
              <div>
                <h3 className="text-lg font-semibold mb-2">Special Request</h3>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-4 mb-6">
                  <div>
                    <label className="text-gray-600">Engine Return:</label>
                    <div>{renderYesNoNA(customer?.engine_return)}</div>
                  </div>
                  <div>
                    <label className="text-gray-600">
                      Lead Battery Return:
                    </label>
                    <div>{renderYesNoNA(customer?.lead_battery_return)}</div>
                  </div>
                  <div>
                    <label className="text-gray-600">Tyre Return:</label>
                    <div>{renderYesNoNA(customer?.tyre_return)}</div>
                  </div>
                  <div>
                    <label className="text-gray-600">Wheel Return:</label>
                    <div>{renderYesNoNA(customer?.wheel_return)}</div>
                  </div>
                  <div>
                    <label className="text-gray-600">Painting Required:</label>
                    <div>{renderYesNoNA(customer?.painting_required)}</div>
                  </div>
                  {customer?.painting_required === 1 && (
                    <div>
                      <label className="text-gray-600">Paint Color:</label>
                      <div>{customer?.paint_color ?? "N/A"}</div>
                    </div>
                  )}
                </div>
              </div>

              {/* RTO Requirements */}
              <div>
                <h3 className="text-lg font-semibold mb-2">RTO Requirements</h3>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-4">
                  <div>
                    <label className="text-gray-600">RTO Interested:</label>
                    <div>{renderYesNoNA(customer?.RTOIntrested)}</div>
                  </div>
                  <div>
                    <label className="text-gray-600">RC Expiry:</label>
                    <div>{formatDate(customer?.RCExpiry)}</div>
                  </div>
                  <div>
                    <label className="text-gray-600">FC Valid:</label>
                    <div>{renderYesNoNA(customer?.fc_valid)}</div>
                  </div>
                  {customer?.fc_valid === 1 && (
                    <div>
                      <label className="text-gray-600">FC Expiry Date:</label>
                      <div>{formatDate(customer?.fc_expiry_date)}</div>
                    </div>
                  )}

                  <div>
                    <label className="text-gray-600">
                      Type Conversion Required:
                    </label>
                    <div>
                      {renderYesNoNA(customer?.type_conversion_required)}
                    </div>
                  </div>
                  <div>
                    <label className="text-gray-600">
                      Fitness Extension Required:
                    </label>
                    <div>
                      {renderYesNoNA(customer?.fitness_extension_required)}
                    </div>
                  </div>
                  <div>
                    <label className="text-gray-600">
                      Duplicate RC Required:
                    </label>
                    <div>{renderYesNoNA(customer?.duplicate_rc_required)}</div>
                  </div>
                  <div>
                    <label className="text-gray-600">
                      Change in Ownership Required:
                    </label>
                    <div>
                      {renderYesNoNA(customer?.change_in_ownership_required)}
                    </div>
                  </div>
                  <div>
                    <label className="text-gray-600">
                      Change in Address Required:
                    </label>
                    <div>
                      {renderYesNoNA(customer?.change_in_address_required)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <ErrorFallback message="Customer data not available." />
      )}
    </div>
  );
};

export default CustomerProfile;
